import React from 'react';
export function ProductSection() {
  const features = ['33 rituales secuenciados que podés hacer en cualquier orden', 'Cada ritual dura entre 10 y 25 minutos — sin una tarde entera', 'Escritura + acto simbólico + integración en cada ritual', 'Sin tecnología especial — solo vos y un espacio tranquilo', 'Base científica terapéutica, no esotérica', 'Acceso inmediato en PDF después de la compra', 'No necesitás experiencia previa — funciona desde el primero'];
  return <section id="product" className="py-12 md:py-16" style={{
    background: 'var(--nude-warm)'
  }} data-id="element-241">
      <div className="max-w-[960px] mx-auto px-5" data-id="element-242">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-243">
          <div className="fade-in text-center md:text-left" data-id="element-244">
            <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/EBOOK.png?v=1772815275" alt="Ebook 33 Rituales para Soltar el Pasado" className="w-full max-w-[300px] md:max-w-[380px] mx-auto md:mx-0 rounded-lg" style={{
            filter: 'drop-shadow(0 20px 44px rgba(180,122,138,.3))'
          }} data-id="element-245" />
          </div>

          <div className="fade-in" data-id="element-246">
            <span className="inline-block text-[10px] font-medium tracking-[3px] uppercase py-1.5 px-4 rounded-full mb-4" style={{
            background: 'var(--rose-deep)',
            color: '#fff'
          }} data-id="element-247">
              Producto principal
            </span>

            <h2 className="font-serif font-normal mb-3" style={{
            fontSize: 'clamp(26px, 4vw, 40px)',
            color: 'var(--ink)'
          }} data-id="element-248">
              <em style={{
              color: 'var(--rose-deep)',
              fontStyle: 'italic'
            }} data-id="element-249">
                33 Rituales
              </em>
              <br data-id="element-250" />
              para Soltar el Pasado
            </h2>

            <p className="text-[14px] mb-5 leading-relaxed" style={{
            color: 'var(--muted)'
          }} data-id="element-251">
              Un ebook de{' '}
              <strong style={{
              color: 'var(--ink)',
              fontWeight: 500
            }} data-id="element-252">
                rituales simbólicos guiados paso a paso
              </strong>
              , combinados con escritura terapéutica y reflexión personal. Cada
              ritual trabaja un tipo de cierre diferente:{' '}
              <em data-id="element-253">
                relaciones, duelos, decisiones, versiones de vos misma que ya no
                existen
              </em>
              .
            </p>

            <ul className="list-none mb-5" data-id="element-254">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-2.5 py-2 text-[13px] leading-snug" style={{
              borderBottom: '1px solid rgba(200,169,110,.18)',
              color: 'var(--ink-soft)'
            }} data-id="element-255">
                  <span className="text-[9px] mt-1 flex-shrink-0" style={{
                color: 'var(--gold)'
              }} data-id="element-256">
                    ✦
                  </span>
                  {feature}
                </li>)}
            </ul>

            <a href="https://ebookpromax.com/cart/46586630013086:1" onClick={() => {
            const fbq = (window as any).fbq;
            if (fbq) {
              fbq('track', 'AddToCart', {
                content_name: 'Kit Digital 33 Rituales para Soltar el Pasado',
                content_type: 'product',
                value: 14990,
                currency: 'CLP'
              });
            }
          }} className="inline-block font-sans font-medium text-[12px] tracking-[2.5px] uppercase py-4 px-8 rounded no-underline relative overflow-hidden transition-all duration-300 hover:-translate-y-[3px]" style={{
            background: 'linear-gradient(135deg, var(--gold), var(--gold-shine), var(--gold))',
            backgroundSize: '200% 100%',
            color: 'var(--ink)',
            boxShadow: '0 6px 28px rgba(200,169,110,.4)'
          }} data-id="element-257">
              <span className="relative z-10" data-id="element-258">Ver la oferta completa </span>
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,.3), transparent 60%)'
            }} data-id="element-259" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}